(() => {
  const selector = '[data-vena-fit-drawer]';

  const initialiseDrawer = (drawer) => { 
    if (drawer.dataset.venaFitReady === 'true') return;
    const summary = drawer.querySelector('summary');
    const content = drawer.querySelector('.vena-fit__choice-content');
    if (!summary || !content) return;

    drawer.dataset.venaFitReady = 'true';
    let animation;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const finish = (open) => {
      drawer.open = open;
      drawer.classList.remove('is-opening', 'is-closing');
      drawer.style.height = '';
      drawer.style.overflow = '';
      animation = null;
    };

    const openDrawer = () => {
      const startHeight = `${drawer.offsetHeight}px`;
      drawer.open = true;
      drawer.classList.add('is-opening');
      const endHeight = `${drawer.offsetHeight}px`;

      if (reducedMotion) {
        finish(true);
        return;
      }

      drawer.style.height = startHeight;
      drawer.style.overflow = 'hidden';
      animation = drawer.animate(
        { height: [startHeight, endHeight] },
        { duration: 300, easing: 'cubic-bezier(.22, .8, .22, 1)' }
      );
      animation.onfinish = () => finish(true);
      animation.oncancel = () => finish(true);
    };

    const closeDrawer = () => {
      const startHeight = `${drawer.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight}px`;
      drawer.classList.add('is-closing');

      if (reducedMotion) {
        finish(false);
        return;
      }

      drawer.style.height = startHeight;
      drawer.style.overflow = 'hidden';
      animation = drawer.animate(
        { height: [startHeight, endHeight] },
        { duration: 250, easing: 'cubic-bezier(.4, 0, .2, 1)' }
      );
      animation.onfinish = () => finish(false);
      animation.oncancel = () => finish(false);
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (animation) animation.cancel();
      drawer.open ? closeDrawer() : openDrawer();
    });
  };

  const initialise = (scope = document) => {
    const drawers = scope.matches?.(selector) ? [scope] : scope.querySelectorAll(selector);
    drawers.forEach(initialiseDrawer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
